export default __webpack_public_path__ + "static/media/3.e3a94e42.jpg";